export default function CardIcon() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.1593 27.2437H16.875V12.8848H9.94939C9.46623 12.8848 9.00869 13.1021 8.70341 13.4766L3.69486 19.6208C3.46103 19.9076 3.33333 20.2664 3.33333 20.6364V26.7079C3.33333 27.0038 3.57324 27.2437 3.86917 27.2437H6.98672V27.2437"
                stroke="#03060B"
                strokeWidth="2"
            />
            <path
                d="M24.9745 27.2437C23.1746 27.2437 20.4747 27.2437 16.8749 27.2437V10.9463C16.8749 10.1847 17.5206 9.56738 18.317 9.56738H35.0162C35.8126 9.56738 36.4583 10.1847 36.4583 10.9463V25.8647C36.4583 26.6263 35.8126 27.2437 35.0162 27.2437C33.7298 27.2437 32.7926 27.2437 32.2046 27.2437"
                stroke="#03060B"
                strokeWidth="2"
            />
            <ellipse cx="3.61111" cy="3.58974" rx="3.61111" ry="3.58974" transform="matrix(-1 0 0 1 14.1665 23.6538)" stroke="#F7A40A" strokeWidth="2" />
            <ellipse cx="3.61111" cy="3.58974" rx="3.61111" ry="3.58974" transform="matrix(-1 0 0 1 32.2222 23.6538)" stroke="#F7A40A" strokeWidth="2" />
        </svg>
    );
}
